import useEditCharacterSpell from '../composables/useEditCharacterSpell'
//------------------------------
// edit character spells harness
//------------------------------
export default async function useEditCharacterSpellsHarness(changed_spells) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterSpellsHarness')
  const spellBatchSummary = (changed_spells || []).map((spell) => ({
    name: spell?.name ?? spell?.payload?.name ?? null,
    action: spell?.action ?? null,
    id: spell?.id ?? spell?.payload?.id ?? null,
    type: spell?.type ?? spell?.payload?.type ?? null,
    character_item: spell?.payload?.character_item ?? null,
    character_rune: spell?.payload?.character_rune ?? null,
    source_name: spell?.source_name ?? null,
    casting_rune_name: spell?.casting_rune_name ?? null,
  }))
  console.log('[RECOVERABLE_ARTEFACT_TRACE] useEditCharacterSpellsHarness batch', spellBatchSummary)
  console.log(
    '[RECOVERABLE_ARTEFACT_TRACE] useEditCharacterSpellsHarness batch json',
    JSON.stringify(spellBatchSummary),
  )
  //-------------------------------------------
  // manages all character spell updates (CRUD)
  //-------------------------------------------
  //--------------------------------------------------------------
  // process spell updates one at a time (not concurrently) - the
  // dev/sqlite backend only supports a single writer at a time,
  // so firing these in parallel (Promise.all) can trigger
  // "database is locked" errors when a single logical operation
  // (e.g. deleting an artefact with multiple linked spells)
  // needs to persist more than one spell change.
  //--------------------------------------------------------------
  const results = []
  for (const r of changed_spells) {
    console.log('IN useEditCharacterSpellsHarness - PROCESSING SPELL:', r)
    //-------------------
    // call api function
    //-------------------
    // eslint-disable-next-line no-await-in-loop
    results.push(await useEditCharacterSpell(r))
  }
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  // return
}
